// Multilingual translations for RS Service rental app
// Languages: Deutsch (de), Français (fr), English (en), Tamil (ta), Tigrinya (ti), Arabic (ar)
// NOTE: Tigrinya & Arabic translations are MACHINE TRANSLATIONS (Beta) — should be reviewed
// by a native speaker before being used in production communication.

export const LANGUAGES = [
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "ta", label: "TA", name: "தமிழ்" },
  { code: "ti", label: "TI", name: "ትግርኛ" },
  { code: "ar", label: "AR", name: "العربية" },
];

// Languages that should be rendered right-to-left
export const RTL_LANGUAGES = ["ar"];

export const translations = {
  de: {
    brand_tagline: "Transporter Vermietung",
    nav_admin: "Admin",
    nav_logout: "Abmelden",
    hero_eyebrow: "Schweizer Transporter-Vermietung",
    hero_title: "Transporter mieten.\nIn Minuten.",
    hero_sub: "Mercedes Vito und Renault Master. Festpreis 700 CHF für 5 Tage. Vollgetankt. Ohne Überraschungen.",
    cta_start: "Vermietung starten",
    cta_admin_login: "Admin-Bereich",
    rental_type_title: "Tarif wählen",
    rental_type_daily: "Tagesmiete · 24h",
    rental_type_daily_desc: "CHF 140.– pro 24 Stunden",
    rental_type_hourly: "Stundentarif",
    rental_type_hourly_desc: "CHF 25.–/h · 200 km inkl. · CHF 0.25/km extra",
    expected_km: "Geplante km",
    duration: "Dauer",
    hours_short: "h",
    total_price: "Gesamtpreis",
    station_title: "Station Manager",
    station_sub: "Fahrzeuge vorbereiten · Übergaben · Rückgaben",
    status_pending: "Offen",
    status_ready: "Bereit",
    status_handed_over: "Übergeben",
    status_returned: "Zurückgegeben",
    status_completed: "Abgeschlossen",
    status_cancelled: "Storniert",
    set_status: "Status setzen",
    odometer_start: "KM-Stand Start",
    odometer_end: "KM-Stand Ende",
    mark_ready: "Als bereit markieren",
    mark_handed_over: "Übergeben",
    mark_returned: "Zurückgegeben",
    mark_completed: "Abschliessen",
    stats_total_contracts: "Verträge gesamt",
    stats_total_revenue: "Umsatz CHF",
    stats_total_hours: "Stunden gesamt",
    stats_per_vehicle: "Auswertung pro Fahrzeug",
    stats_status: "Status-Übersicht",
    nav_calendar: "Kalender",
    nav_register: "Registrieren",
    nav_my: "Mein Bereich",
    nav_login: "Anmelden",
    register_title: "Kundenkonto erstellen",
    register_sub: "Schnell registrieren und direkt online buchen.",
    register_cta: "Konto erstellen",
    have_account: "Bereits registriert?",
    no_account: "Noch kein Konto?",
    calendar_title: "Verfügbarkeit",
    calendar_sub: "Übersicht gebucht / frei pro Fahrzeug.",
    calendar_legend_free: "Frei",
    calendar_legend_partial: "Teilweise",
    calendar_legend_booked: "Gebucht",
    my_title: "Meine Buchungen",
    my_sub: "Übersicht Ihrer Mietverträge.",
    book_now: "Jetzt buchen",
    conflict_error: "Fahrzeug ist im gewählten Zeitraum bereits gebucht.",
    handover_title: "Fahrzeug-Übergabe dokumentieren",
    return_title: "Fahrzeug-Rückgabe dokumentieren",
    odometer_helper: "Aktueller Kilometerstand vom Tacho ablesen.",
    vehicle_photo: "Fahrzeug-Foto",
    vehicle_photo_hint: "Foto vom Fahrzeug aufnehmen (Schäden / Allgemeinzustand)",
    profile_title: "Mein Profil",
    profile_sub: "Daten werden bei jeder Buchung automatisch übernommen.",
    profile_save: "Profil speichern",
    profile_saved: "Profil gespeichert",
    handover_photo_label: "Übergabe-Foto",
    return_photo_label: "Rückgabe-Foto",
    agb_title: "AGB · Allgemeine Geschäftsbedingungen",
    agb_accept_label: "Ich habe die AGB gelesen, verstanden und akzeptiere sie. Mit dem Bestätigen wird der Mietvertrag rechtsgültig.",
    agb_required: "Bitte AGB akzeptieren, um fortzufahren.",
    defects_label: "Mängel bei Übernahme (optional)",
    defects_placeholder: "z.B. Kratzer hinten rechts, Steinschlag Frontscheibe oben...",
    defects_helper: "Etwaige Mängel bitte detailliert auflisten. Nicht erfasste Schäden gehen zulasten des Mieters.",
    step_vehicle: "Fahrzeug",
    step_customer: "Kundendaten",
    step_id: "Ausweis",
    step_signature: "Unterschrift",
    step_review: "Übersicht",
    step_done: "Abgeschlossen",
    summary_title: "Ihre Buchung",
    summary_terms: "Konditionen",
    summary_price: "Mietpreis",
    summary_price_value: "CHF 140.– / 24h",
    summary_deposit: "Kaution",
    summary_deductible: "Selbstbehalt",
    summary_fuel: "Treibstoff",
    summary_fuel_value: "Vollgetankt bei Übergabe & Rückgabe",
    summary_vehicle: "Fahrzeug",
    summary_no_vehicle: "Noch nicht ausgewählt",
    select_vehicle: "Wählen Sie Ihr Fahrzeug",
    select_vehicle_sub: "Beide Fahrzeuge sind voll versichert und vollgetankt zur Übergabe bereit.",
    plate: "Kennzeichen",
    capacity: "Laderaum",
    max_weight: "Nutzlast",
    btn_select: "Auswählen",
    btn_back: "Zurück",
    btn_next: "Weiter",
    btn_confirm: "Vertrag bestätigen",
    btn_capture: "Foto aufnehmen",
    btn_retake: "Neu aufnehmen",
    btn_use_photo: "Foto verwenden",
    btn_clear: "Löschen",
    customer_title: "Kundendaten",
    customer_sub: "Bitte alle Felder ausfüllen wie auf dem Führerschein.",
    f_full_name: "Vollständiger Name",
    f_address: "Adresse",
    f_city: "Ort",
    f_postal: "PLZ",
    f_phone: "Telefon",
    f_email: "E-Mail (optional)",
    f_license: "Führerscheinnummer",
    f_dob: "Geburtsdatum",
    f_start: "Mietbeginn",
    f_end: "Mietende (24h)",
    id_title: "Ausweis fotografieren",
    id_sub: "Halten Sie den Führerschein gut lesbar in den Rahmen.",
    id_camera_off: "Kamera nicht verfügbar",
    id_grant: "Bitte erlauben Sie den Kamerazugriff im Browser.",
    id_or_upload: "Oder Bild hochladen",
    sig_title: "Digitale Unterschrift",
    sig_sub: "Unterschreiben Sie hier, um den Mietvertrag rechtsgültig abzuschliessen.",
    sig_baseline: "Unterschrift",
    review_title: "Vertrag prüfen",
    review_sub: "Prüfen Sie alle Angaben vor dem Abschluss.",
    confirmation_title: "Vertrag erfolgreich erstellt",
    confirmation_sub: "Der Mietvertrag wurde gespeichert.",
    contract_number: "Vertragsnummer",
    download_pdf: "PDF herunterladen",
    new_contract: "Neuer Vertrag",
    login_title: "Admin Anmeldung",
    login_sub: "Zugang nur für berechtigtes Personal von NIVARA.",
    login_back: "Zurück zur App",
    login_hero_a: "Mieten.",
    login_hero_b: "Losfahren.",
    login_hero_text: "Ihre Transporter, sofort verfügbar. Buchen Sie online und übernehmen Sie an einem unserer Standorte in St. Gallen, Bern oder Derendingen.",
    f_email_login: "E-Mail",
    f_password: "Passwort",
    btn_login: "Anmelden",
    login_error: "Ungültige Anmeldedaten",
    admin_title: "Verträge",
    admin_sub: "Alle aktiven und vergangenen Mietverträge.",
    search_placeholder: "Suche nach Name, Vertragsnummer, Führerschein…",
    filter_all: "Alle Fahrzeuge",
    th_contract: "Vertrag",
    th_customer: "Kunde",
    th_vehicle: "Fahrzeug",
    th_period: "Zeitraum",
    th_price: "Preis",
    th_actions: "",
    no_contracts: "Keine Verträge gefunden.",
    view: "Anzeigen",
    pdf: "PDF",
    delete: "Löschen",
    confirm_delete: "Vertrag wirklich löschen?",
    required: "Pflichtfeld",
    saving: "Speichern…",
    days: "Tage",
    beta_notice: "",
    // ── new keys added for full translation coverage ──
    step_config: "Konfiguration",
    vehicle_pick_type_title: "Was möchten Sie transportieren?",
    vehicle_pick_type_sub: "Personen oder Waren? In zwei Klicks zum richtigen Fahrzeug.",
    vehicle_pick_station_title: "Standort wählen",
    vehicle_pick_station_sub: "Wählen Sie den Abholort. Das passende Fahrzeug wird automatisch reserviert.",
    vehicle_type_passenger: "Personentransporter",
    vehicle_type_passenger_sub: "Mercedes Vito · 9 Sitzplätze",
    vehicle_type_cargo: "Warentransporter",
    vehicle_type_cargo_sub: "Renault Master · bis 1500 kg",
    price_from_per_day: "ab CHF 190.– / Tag",
    price_from_per_3h: "ab CHF 80.– / 3h",
    change_vehicle_type: "Fahrzeugtyp ändern",
    station_label: "Standort",
    selected_label: "Ausgewählt",
    no_stations_available: "Aktuell keine Standorte verfügbar.",
    pickup_location: "Abholort",
    pickup_location_pick: "Abholort wählen",
    vito_config_eyebrow: "Vito · Konfiguration",
    vito_config_title: "Reise konfigurieren",
    vito_config_sub: "Reiseziel, Start- und Rückgabezeit. Ohne km-Limit.",
    destination_label: "Reiseziel",
    destination_ch: "Schweiz",
    destination_ch_sub: "Inland",
    destination_eu: "Ausland (EU)",
    destination_eu_sub: "Europa",
    start_date: "Startdatum",
    start_time: "Startzeit",
    handover_time_hint: "Übergabezeit am Abholort.",
    days_count_label: "Anzahl Tage (1–14)",
    day_singular: "Tag",
    weekend_tariff: "Wochenend-Tarif",
    weekday_tariff: "Werktage-Tarif",
    vito_price_footer: "Ohne km-Limit · Vollkasko inkl. CHF 1'000 Selbstbehalt",
    master_config_eyebrow: "Master · Paket",
    master_config_title: "Paket wählen",
    master_config_sub: "3 Pakete mit km inklusive. Mehr-km CHF 0.35 / km. Mittwochs geschlossen.",
    package_label: "Paket",
    km_included: "km inkl.",
    km_included_short: "inkl.",
    date_label: "Datum",
    wednesday_blocked: "Mittwoch ist nicht buchbar.",
    start_time_range: "Startzeit (08:00–20:00)",
    opening_hours_only: "Nur 08:00–20:00 Uhr",
    expected_km_opt: "Geplante km (optional)",
    package_price: "Paketpreis",
    extra_km_overtime_info: "Mehr-km CHF 0.35 · Überzeit CHF 25/h",
    master_price_footer: "Vollkasko inkl. · Mittwochs geschlossen",
    customer_search_title: "Bestehenden Kunden suchen",
    customer_search_placeholder: "Name, Führerscheinnummer, Telefon oder E-Mail…",
    searching: "Suche…",
    no_results: "Keine Treffer.",
    payment_method_label: "Zahlungsart bei Abholung",
    payment_twint_sub: "QR-Code im Vertrag · Mobile Zahlung",
    payment_cash_title: "Barzahlung",
    payment_cash_sub: "Bezahlung in CHF bei Fahrzeugabholung",
    vehicles_load_error: "Fahrzeuge konnten nicht geladen werden.",
    submit_error: "Fehler beim Speichern. Bitte erneut versuchen.",
    term_master_packages: "Master-Pakete",
    term_extra_km: "Mehr-km",
    term_overtime: "Überzeit",
    term_daily_ch: "Tagesmiete (CH)",
    term_abroad_eu: "Ausland (EU)",
    term_from: "ab",
    term_km_limit: "km-Limit",
    term_km_none: "ohne",
    summary_brand_tag: "Vermietung Transporter",
    language_label: "Sprache",
    confirmation_sent_email: "Eine Bestätigung wurde an {email} gesendet.",
    confirmation_no_email: "Bitte notieren Sie die Vertragsnummer für die Übergabe.",
    confirmation_help: "Bei Fragen einfach anrufen:",
    send_by_email: "Per E-Mail senden",
    back_to_home: "Zurück zur Startseite",
    btn_cancel: "Abbrechen",
    btn_send: "Senden",
  },
  fr: {
    brand_tagline: "Location de fourgons",
    nav_admin: "Admin",
    nav_logout: "Se déconnecter",
    rental_type_title: "Choisir le tarif",
    rental_type_daily: "Forfait journée · 24h",
    rental_type_daily_desc: "CHF 140.– par 24 heures",
    rental_type_hourly: "Tarif horaire",
    rental_type_hourly_desc: "CHF 25.–/h · 200 km inclus · CHF 0.25/km extra",
    expected_km: "Km prévus",
    duration: "Durée",
    hours_short: "h",
    total_price: "Prix total",
    station_title: "Station Manager",
    station_sub: "Préparer · Remettre · Restituer",
    status_pending: "En attente",
    status_ready: "Prêt",
    status_handed_over: "Remis",
    status_returned: "Restitué",
    status_completed: "Terminé",
    status_cancelled: "Annulé",
    set_status: "Changer statut",
    odometer_start: "KM départ",
    odometer_end: "KM retour",
    mark_ready: "Marquer prêt",
    mark_handed_over: "Remettre",
    mark_returned: "Réceptionner",
    mark_completed: "Clôturer",
    stats_total_contracts: "Total contrats",
    stats_total_revenue: "Revenus CHF",
    stats_total_hours: "Heures totales",
    stats_per_vehicle: "Par véhicule",
    stats_status: "Statuts",
    nav_calendar: "Calendrier",
    nav_register: "S'inscrire",
    nav_my: "Mon espace",
    nav_login: "Se connecter",
    register_title: "Créer un compte client",
    register_sub: "Inscrivez-vous et réservez en ligne.",
    register_cta: "Créer le compte",
    have_account: "Déjà inscrit ?",
    no_account: "Pas encore de compte ?",
    calendar_title: "Disponibilité",
    calendar_sub: "Aperçu réservé / libre par véhicule.",
    calendar_legend_free: "Libre",
    calendar_legend_partial: "Partiel",
    calendar_legend_booked: "Réservé",
    my_title: "Mes réservations",
    my_sub: "Aperçu de vos contrats.",
    book_now: "Réserver",
    conflict_error: "Le véhicule est déjà réservé sur cette période.",
    handover_title: "Documenter la remise du véhicule",
    return_title: "Documenter le retour du véhicule",
    odometer_helper: "Relever le compteur kilométrique actuel.",
    vehicle_photo: "Photo du véhicule",
    vehicle_photo_hint: "Photographier le véhicule (dommages / état général)",
    profile_title: "Mon profil",
    profile_sub: "Vos données seront pré-remplies à chaque réservation.",
    profile_save: "Enregistrer",
    profile_saved: "Profil enregistré",
    handover_photo_label: "Photo remise",
    return_photo_label: "Photo retour",
    agb_title: "CGV · Conditions générales",
    agb_accept_label: "J'ai lu, compris et j'accepte les CGV. La validation rend le contrat de location juridiquement contraignant.",
    agb_required: "Veuillez accepter les CGV pour continuer.",
    defects_label: "Défauts à la prise (facultatif)",
    defects_placeholder: "ex. rayure arrière droite, impact sur le pare-brise...",
    defects_helper: "Listez les défauts en détail. Les dommages non documentés sont à la charge du locataire.",
    hero_eyebrow: "Location suisse de fourgons",
    hero_title: "Louez un fourgon.\nEn quelques minutes.",
    hero_sub: "Mercedes Vito et Renault Master. Forfait de 700 CHF pour 5 jours. Plein fait. Sans surprise.",
    cta_start: "Démarrer la location",
    cta_admin_login: "Espace admin",
    step_vehicle: "Véhicule",
    step_customer: "Client",
    step_id: "Pièce d'identité",
    step_signature: "Signature",
    step_review: "Récapitulatif",
    step_done: "Terminé",
    summary_title: "Votre réservation",
    summary_terms: "Conditions",
    summary_price: "Prix",
    summary_price_value: "CHF 140.– / 24h",
    summary_deposit: "Caution",
    summary_deductible: "Franchise",
    summary_fuel: "Carburant",
    summary_fuel_value: "Plein à la prise et au retour",
    summary_vehicle: "Véhicule",
    summary_no_vehicle: "Non sélectionné",
    select_vehicle: "Choisissez votre véhicule",
    select_vehicle_sub: "Les deux véhicules sont entièrement assurés et le plein est fait.",
    plate: "Immatriculation",
    capacity: "Volume",
    max_weight: "Charge utile",
    btn_select: "Sélectionner",
    btn_back: "Retour",
    btn_next: "Suivant",
    btn_confirm: "Confirmer le contrat",
    btn_capture: "Prendre la photo",
    btn_retake: "Reprendre",
    btn_use_photo: "Utiliser la photo",
    btn_clear: "Effacer",
    customer_title: "Données client",
    customer_sub: "Remplissez tous les champs comme sur le permis de conduire.",
    f_full_name: "Nom complet",
    f_address: "Adresse",
    f_city: "Ville",
    f_postal: "NPA",
    f_phone: "Téléphone",
    f_email: "E-mail (facultatif)",
    f_license: "N° de permis",
    f_dob: "Date de naissance",
    f_start: "Début location",
    f_end: "Fin location (24h)",
    id_title: "Photo de la pièce d'identité",
    id_sub: "Cadrez bien le permis dans la zone.",
    id_camera_off: "Caméra non disponible",
    id_grant: "Veuillez autoriser l'accès à la caméra.",
    id_or_upload: "Ou téléverser une image",
    sig_title: "Signature numérique",
    sig_sub: "Signez pour valider le contrat.",
    sig_baseline: "Signature",
    review_title: "Vérification",
    review_sub: "Vérifiez les informations avant validation.",
    confirmation_title: "Contrat créé avec succès",
    confirmation_sub: "Le contrat de location a été enregistré.",
    contract_number: "N° de contrat",
    download_pdf: "Télécharger PDF",
    new_contract: "Nouveau contrat",
    login_title: "Connexion admin",
    login_sub: "Accès réservé au personnel NIVARA.",
    login_back: "Retour à l'application",
    login_hero_a: "Louez.",
    login_hero_b: "Partez.",
    login_hero_text: "Vos utilitaires, immédiatement disponibles. Réservez en ligne et prenez-les en charge dans l'une de nos stations à Saint-Gall, Berne ou Derendingen.",
    f_email_login: "E-mail",
    f_password: "Mot de passe",
    btn_login: "Se connecter",
    login_error: "Identifiants invalides",
    admin_title: "Contrats",
    admin_sub: "Tous les contrats actifs et passés.",
    search_placeholder: "Rechercher par nom, n° de contrat, permis…",
    filter_all: "Tous les véhicules",
    th_contract: "Contrat",
    th_customer: "Client",
    th_vehicle: "Véhicule",
    th_period: "Période",
    th_price: "Prix",
    th_actions: "",
    no_contracts: "Aucun contrat trouvé.",
    view: "Voir",
    pdf: "PDF",
    delete: "Supprimer",
    confirm_delete: "Supprimer ce contrat ?",
    required: "Champ requis",
    saving: "Enregistrement…",
    days: "jours",
    beta_notice: "",
    step_config: "Configuration",
    vehicle_pick_type_title: "Que souhaitez-vous transporter ?",
    vehicle_pick_type_sub: "Personnes ou marchandises ? Le bon véhicule en deux clics.",
    vehicle_pick_station_title: "Choisir le site",
    vehicle_pick_station_sub: "Choisissez le lieu de prise en charge. Le véhicule adapté sera réservé automatiquement.",
    vehicle_type_passenger: "Transport de personnes",
    vehicle_type_passenger_sub: "Mercedes Vito · 9 places",
    vehicle_type_cargo: "Utilitaire marchandises",
    vehicle_type_cargo_sub: "Renault Master · jusqu'à 1500 kg",
    price_from_per_day: "dès CHF 190.– / jour",
    price_from_per_3h: "dès CHF 80.– / 3h",
    change_vehicle_type: "Changer de type",
    station_label: "Site",
    selected_label: "Sélectionné",
    no_stations_available: "Aucun site disponible actuellement.",
    pickup_location: "Lieu de prise",
    pickup_location_pick: "Choisir le lieu de prise",
    vito_config_eyebrow: "Vito · Configuration",
    vito_config_title: "Configurer le trajet",
    vito_config_sub: "Destination, date/heure de départ et de retour. Sans limite de km.",
    destination_label: "Destination",
    destination_ch: "Suisse",
    destination_ch_sub: "Intérieur",
    destination_eu: "Étranger (UE)",
    destination_eu_sub: "Europe",
    start_date: "Date de départ",
    start_time: "Heure de départ",
    handover_time_hint: "Heure de remise sur le site.",
    days_count_label: "Nombre de jours (1–14)",
    day_singular: "jour",
    weekend_tariff: "Tarif week-end",
    weekday_tariff: "Tarif semaine",
    vito_price_footer: "Sans limite de km · Tous risques avec CHF 1'000 de franchise",
    master_config_eyebrow: "Master · Forfait",
    master_config_title: "Choisir un forfait",
    master_config_sub: "3 forfaits avec km inclus. Km supplémentaires CHF 0.35 / km. Fermé le mercredi.",
    package_label: "Forfait",
    km_included: "km inclus",
    km_included_short: "inclus",
    date_label: "Date",
    wednesday_blocked: "Mercredi non réservable.",
    start_time_range: "Heure de départ (08:00–20:00)",
    opening_hours_only: "Uniquement 08:00–20:00",
    expected_km_opt: "Km prévus (facultatif)",
    package_price: "Prix du forfait",
    extra_km_overtime_info: "Km sup. CHF 0.35 · Heures sup. CHF 25/h",
    master_price_footer: "Tous risques inclus · Fermé le mercredi",
    customer_search_title: "Rechercher un client existant",
    customer_search_placeholder: "Nom, n° de permis, téléphone ou e-mail…",
    searching: "Recherche…",
    no_results: "Aucun résultat.",
    payment_method_label: "Mode de paiement à la prise",
    payment_twint_sub: "QR Code sur le contrat · paiement mobile",
    payment_cash_title: "Espèces",
    payment_cash_sub: "Paiement en CHF lors de la prise du véhicule",
    vehicles_load_error: "Impossible de charger les véhicules.",
    submit_error: "Erreur lors de l'enregistrement. Veuillez réessayer.",
    term_master_packages: "Forfaits Master",
    term_extra_km: "Km sup.",
    term_overtime: "Heures sup.",
    term_daily_ch: "Forfait journée (CH)",
    term_abroad_eu: "Étranger (UE)",
    term_from: "dès",
    term_km_limit: "Limite km",
    term_km_none: "aucune",
    summary_brand_tag: "Location de fourgons",
    language_label: "Langue",
    confirmation_sent_email: "Une confirmation a été envoyée à {email}.",
    confirmation_no_email: "Veuillez noter le numéro de contrat pour la prise du véhicule.",
    confirmation_help: "Pour toute question, appelez-nous :",
    send_by_email: "Envoyer par e-mail",
    back_to_home: "Retour à l'accueil",
    btn_cancel: "Annuler",
    btn_send: "Envoyer",
  },
  en: {
    brand_tagline: "Van Rental",
    nav_admin: "Admin",
    nav_logout: "Logout",
    rental_type_title: "Choose tariff",
    rental_type_daily: "Daily · 24h",
    rental_type_daily_desc: "CHF 140.– per 24 hours",
    rental_type_hourly: "Hourly",
    rental_type_hourly_desc: "CHF 25.–/h · 200 km included · CHF 0.25/extra km",
    expected_km: "Expected km",
    duration: "Duration",
    hours_short: "h",
    total_price: "Total price",
    station_title: "Station Manager",
    station_sub: "Prepare · Hand over · Return",
    status_pending: "Pending",
    status_ready: "Ready",
    status_handed_over: "Handed over",
    status_returned: "Returned",
    status_completed: "Completed",
    status_cancelled: "Cancelled",
    set_status: "Change status",
    odometer_start: "ODO start",
    odometer_end: "ODO end",
    mark_ready: "Mark ready",
    mark_handed_over: "Hand over",
    mark_returned: "Mark returned",
    mark_completed: "Complete",
    stats_total_contracts: "Total contracts",
    stats_total_revenue: "Revenue CHF",
    stats_total_hours: "Total hours",
    stats_per_vehicle: "Per vehicle",
    stats_status: "Status",
    nav_calendar: "Calendar",
    nav_register: "Register",
    nav_my: "My area",
    nav_login: "Login",
    register_title: "Create customer account",
    register_sub: "Register and book directly online.",
    register_cta: "Create account",
    have_account: "Already have an account?",
    no_account: "No account yet?",
    calendar_title: "Availability",
    calendar_sub: "Overview booked / free per vehicle.",
    calendar_legend_free: "Free",
    calendar_legend_partial: "Partial",
    calendar_legend_booked: "Booked",
    my_title: "My bookings",
    my_sub: "Overview of your rental contracts.",
    book_now: "Book now",
    conflict_error: "Vehicle already booked for the selected period.",
    handover_title: "Document vehicle handover",
    return_title: "Document vehicle return",
    odometer_helper: "Read the current odometer value.",
    vehicle_photo: "Vehicle photo",
    vehicle_photo_hint: "Take a photo of the vehicle (damage / overall condition)",
    profile_title: "My profile",
    profile_sub: "Saved data will pre-fill every new booking.",
    profile_save: "Save profile",
    profile_saved: "Profile saved",
    handover_photo_label: "Handover photo",
    return_photo_label: "Return photo",
    agb_title: "Terms & Conditions",
    agb_accept_label: "I have read, understood and accept the Terms & Conditions. Confirming makes the rental contract legally binding.",
    agb_required: "Please accept the Terms & Conditions to continue.",
    defects_label: "Defects at handover (optional)",
    defects_placeholder: "e.g. scratch rear right, stone chip windshield top...",
    defects_helper: "Please list any existing defects in detail. Damage not documented will be charged to the renter.",
    hero_eyebrow: "Swiss van rental",
    hero_title: "Rent a van.\nIn minutes.",
    hero_sub: "Mercedes Vito and Renault Master. Flat 700 CHF for 5 days. Full tank. No surprises.",
    cta_start: "Start rental",
    cta_admin_login: "Admin area",
    step_vehicle: "Vehicle",
    step_customer: "Customer",
    step_id: "ID",
    step_signature: "Signature",
    step_review: "Review",
    step_done: "Done",
    summary_title: "Your booking",
    summary_terms: "Terms",
    summary_price: "Price",
    summary_price_value: "CHF 140.– / 24h",
    summary_deposit: "Deposit",
    summary_deductible: "Deductible",
    summary_fuel: "Fuel",
    summary_fuel_value: "Full tank at handover & return",
    summary_vehicle: "Vehicle",
    summary_no_vehicle: "Not selected yet",
    select_vehicle: "Choose your vehicle",
    select_vehicle_sub: "Both vans are fully insured and ready with a full tank.",
    plate: "Plate",
    capacity: "Cargo",
    max_weight: "Payload",
    btn_select: "Select",
    btn_back: "Back",
    btn_next: "Next",
    btn_confirm: "Confirm contract",
    btn_capture: "Take photo",
    btn_retake: "Retake",
    btn_use_photo: "Use photo",
    btn_clear: "Clear",
    customer_title: "Customer details",
    customer_sub: "Fill in every field exactly as on the driver's license.",
    f_full_name: "Full name",
    f_address: "Address",
    f_city: "City",
    f_postal: "ZIP",
    f_phone: "Phone",
    f_email: "Email (optional)",
    f_license: "License number",
    f_dob: "Date of birth",
    f_start: "Rental start",
    f_end: "Rental end (24h)",
    id_title: "Photograph the ID",
    id_sub: "Frame the license inside the dashed area.",
    id_camera_off: "Camera unavailable",
    id_grant: "Please grant camera access in the browser.",
    id_or_upload: "Or upload an image",
    sig_title: "Digital signature",
    sig_sub: "Sign here to make the contract legally binding.",
    sig_baseline: "Signature",
    review_title: "Review the contract",
    review_sub: "Verify all details before submitting.",
    confirmation_title: "Contract successfully created",
    confirmation_sub: "Your rental contract has been saved.",
    contract_number: "Contract no.",
    download_pdf: "Download PDF",
    new_contract: "New contract",
    login_title: "Admin login",
    login_sub: "Access for authorized NIVARA staff only.",
    login_back: "Back to the app",
    login_hero_a: "Rent.",
    login_hero_b: "Drive away.",
    login_hero_text: "Your vans, ready immediately. Book online and pick up at one of our stations in St. Gallen, Bern or Derendingen.",
    f_email_login: "Email",
    f_password: "Password",
    btn_login: "Log in",
    login_error: "Invalid credentials",
    admin_title: "Contracts",
    admin_sub: "All active and past rental contracts.",
    search_placeholder: "Search by name, contract no., license…",
    filter_all: "All vehicles",
    th_contract: "Contract",
    th_customer: "Customer",
    th_vehicle: "Vehicle",
    th_period: "Period",
    th_price: "Price",
    th_actions: "",
    no_contracts: "No contracts found.",
    view: "View",
    pdf: "PDF",
    delete: "Delete",
    confirm_delete: "Really delete this contract?",
    required: "Required",
    saving: "Saving…",
    days: "days",
    beta_notice: "",
    step_config: "Configuration",
    vehicle_pick_type_title: "What do you want to transport?",
    vehicle_pick_type_sub: "People or goods? Two clicks to the right vehicle.",
    vehicle_pick_station_title: "Choose location",
    vehicle_pick_station_sub: "Choose your pickup location. We'll auto-assign the right vehicle.",
    vehicle_type_passenger: "Passenger van",
    vehicle_type_passenger_sub: "Mercedes Vito · 9 seats",
    vehicle_type_cargo: "Cargo van",
    vehicle_type_cargo_sub: "Renault Master · up to 1500 kg",
    price_from_per_day: "from CHF 190.– / day",
    price_from_per_3h: "from CHF 80.– / 3h",
    change_vehicle_type: "Change vehicle type",
    station_label: "Location",
    selected_label: "Selected",
    no_stations_available: "No locations currently available.",
    pickup_location: "Pickup",
    pickup_location_pick: "Choose pickup location",
    vito_config_eyebrow: "Vito · Configuration",
    vito_config_title: "Configure your trip",
    vito_config_sub: "Destination, pick-up and return date/time. No km limit.",
    destination_label: "Destination",
    destination_ch: "Switzerland",
    destination_ch_sub: "Domestic",
    destination_eu: "Abroad (EU)",
    destination_eu_sub: "Europe",
    start_date: "Start date",
    start_time: "Start time",
    handover_time_hint: "Handover time at the location.",
    days_count_label: "Number of days (1–14)",
    day_singular: "day",
    weekend_tariff: "Weekend rate",
    weekday_tariff: "Weekday rate",
    vito_price_footer: "No km limit · Full insurance incl. CHF 1'000 deductible",
    master_config_eyebrow: "Master · Package",
    master_config_title: "Choose a package",
    master_config_sub: "3 packages with km included. Extra km CHF 0.35 / km. Closed Wednesdays.",
    package_label: "Package",
    km_included: "km incl.",
    km_included_short: "incl.",
    date_label: "Date",
    wednesday_blocked: "Wednesday is not bookable.",
    start_time_range: "Start time (08:00–20:00)",
    opening_hours_only: "Only 08:00–20:00",
    expected_km_opt: "Expected km (optional)",
    package_price: "Package price",
    extra_km_overtime_info: "Extra km CHF 0.35 · Overtime CHF 25/h",
    master_price_footer: "Full insurance incl. · Closed Wednesdays",
    customer_search_title: "Search existing customer",
    customer_search_placeholder: "Name, license number, phone or e-mail…",
    searching: "Searching…",
    no_results: "No results.",
    payment_method_label: "Payment on pickup",
    payment_twint_sub: "QR code on contract · mobile payment",
    payment_cash_title: "Cash",
    payment_cash_sub: "Payment in CHF on vehicle pickup",
    vehicles_load_error: "Could not load vehicles.",
    submit_error: "Error while saving. Please try again.",
    term_master_packages: "Master packages",
    term_extra_km: "Extra km",
    term_overtime: "Overtime",
    term_daily_ch: "Daily rate (CH)",
    term_abroad_eu: "Abroad (EU)",
    term_from: "from",
    term_km_limit: "km limit",
    term_km_none: "none",
    summary_brand_tag: "Van rental",
    language_label: "Language",
    confirmation_sent_email: "A confirmation has been sent to {email}.",
    confirmation_no_email: "Please note your contract number for pickup.",
    confirmation_help: "Any questions? Just call us:",
    send_by_email: "Send by e-mail",
    back_to_home: "Back to home",
    btn_cancel: "Cancel",
    btn_send: "Send",
  },
  ta: {
    brand_tagline: "வேன் வாடகை",
    nav_admin: "நிர்வாகம்",
    nav_logout: "வெளியேறு",
    rental_type_title: "கட்டணத்தைத் தேர்ந்தெடு",
    rental_type_daily: "தினச் கட்டணம் · 24 மணி",
    rental_type_daily_desc: "24 மணி நேரத்திற்கு CHF 140.–",
    rental_type_hourly: "மணிநேரக் கட்டணம்",
    rental_type_hourly_desc: "CHF 25.–/மணி · 200 கி.மீ. உட்பட · அதிகக் கி.மீ. CHF 0.25",
    expected_km: "எதிர்பார்த்த கி.மீ.",
    duration: "கால அளவு",
    hours_short: "மணி",
    total_price: "மொத்த விலை",
    station_title: "ஸ்டேஷன் மேலாளர்",
    station_sub: "தயார்படுத்து · ஒப்படை · திரும்பப் பெறு",
    status_pending: "நிலுவை",
    status_ready: "தயார்",
    status_handed_over: "ஒப்படைக்கப்பட்டது",
    status_returned: "திரும்ப பெறப்பட்டது",
    status_completed: "முடிந்தது",
    status_cancelled: "ரத்து",
    set_status: "நிலையை மாற்று",
    odometer_start: "தொடக்க கி.மீ.",
    odometer_end: "முடிவு கி.மீ.",
    mark_ready: "தயார் என்று குறி",
    mark_handed_over: "ஒப்படை",
    mark_returned: "திரும்ப பெற்றது",
    mark_completed: "முடி",
    stats_total_contracts: "மொத்த ஒப்பந்தங்கள்",
    stats_total_revenue: "வருமானம் CHF",
    stats_total_hours: "மொத்த மணி நேரம்",
    stats_per_vehicle: "வாகனம் வாரியாக",
    stats_status: "நிலை",
    nav_calendar: "நாட்காட்டி",
    nav_register: "பதிவு",
    nav_my: "என் பகுதி",
    nav_login: "உள்நுழை",
    register_title: "வாடிக்கையாளர் கணக்கை உருவாக்கு",
    register_sub: "பதிவு செய்து நேரடியாக ஆன்லைனில் முன்பதிவு செய்யுங்கள்.",
    register_cta: "கணக்கை உருவாக்கு",
    have_account: "ஏற்கனவே கணக்கு உள்ளதா?",
    no_account: "கணக்கு இல்லையா?",
    calendar_title: "கிடைக்கும் நிலை",
    calendar_sub: "ஒவ்வொரு வாகனத்திற்கும் முன்பதிவு / கிடைக்கும் கண்ணோட்டம்.",
    calendar_legend_free: "கிடைக்கிறது",
    calendar_legend_partial: "பகுதி",
    calendar_legend_booked: "முன்பதிவு",
    my_title: "என் முன்பதிவுகள்",
    my_sub: "உங்கள் ஒப்பந்தங்களின் கண்ணோட்டம்.",
    book_now: "இப்போது முன்பதிவு செய்",
    conflict_error: "தேர்ந்தெடுக்கப்பட்ட காலத்தில் வாகனம் ஏற்கனவே முன்பதிவு செய்யப்பட்டுள்ளது.",
    handover_title: "வாகன ஒப்படைப்பை பதிவுசெய்க",
    return_title: "வாகன திரும்பப் பெறுதலை பதிவுசெய்க",
    odometer_helper: "தற்போதைய கிலோமீட்டர் அளவை பதிவு செய்யவும்.",
    vehicle_photo: "வாகன புகைப்படம்",
    vehicle_photo_hint: "வாகனத்தின் புகைப்படம் எடுக்கவும் (பழுதுகள் / பொது நிலை)",
    profile_title: "என் சுயவிவரம்",
    profile_sub: "சேமிக்கப்பட்ட தரவு ஒவ்வொரு புதிய முன்பதிவிலும் தானாக நிரப்பப்படும்.",
    profile_save: "சுயவிவரத்தை சேமி",
    profile_saved: "சுயவிவரம் சேமிக்கப்பட்டது",
    handover_photo_label: "ஒப்படைப்பு புகைப்படம்",
    return_photo_label: "திரும்ப பெறுதல் புகைப்படம்",
    agb_title: "பொது விதிமுறைகள்",
    agb_accept_label: "நான் பொது விதிமுறைகளை படித்து, புரிந்து ஏற்றுக்கொண்டேன். உறுதிப்படுத்துவதன் மூலம் வாடகை ஒப்பந்தம் சட்டப்பூர்வமாகும்.",
    agb_required: "தொடர பொது விதிமுறைகளை ஏற்கவும்.",
    defects_label: "ஒப்படைப்பு போது இருக்கும் பழுதுகள் (விருப்பம்)",
    defects_placeholder: "எ.கா. பின்புறம் வலது கீறல், முன் கண்ணாடி கல் தாக்கம்...",
    defects_helper: "தற்போதுள்ள பழுதுகளை விரிவாக பட்டியலிடவும். ஆவணப்படுத்தப்படாத சேதம் வாடகைதாரருக்கு கட்டணம் வசூலிக்கப்படும்.",
    hero_eyebrow: "சுவிஸ் வேன் வாடகை",
    hero_title: "வேன் வாடகைக்கு.\nசில நிமிடங்களில்.",
    hero_sub: "Mercedes Vito மற்றும் Renault Master. 5 நாட்களுக்கு 700 CHF. முழு டாங்க். எந்த ஆச்சரியமும் இல்லை.",
    cta_start: "வாடகை தொடங்கு",
    cta_admin_login: "நிர்வாக பகுதி",
    step_vehicle: "வாகனம்",
    step_customer: "வாடிக்கையாளர்",
    step_id: "அடையாள அட்டை",
    step_signature: "கையொப்பம்",
    step_review: "சரிபார்ப்பு",
    step_done: "முடிந்தது",
    summary_title: "உங்கள் முன்பதிவு",
    summary_terms: "நிபந்தனைகள்",
    summary_price: "விலை",
    summary_price_value: "CHF 140.– / 24 மணி",
    summary_deposit: "வைப்புத்தொகை",
    summary_deductible: "கழிவு",
    summary_fuel: "எரிபொருள்",
    summary_fuel_value: "ஒப்படைப்பு & திரும்பப் பெறும்போது முழு டாங்க்",
    summary_vehicle: "வாகனம்",
    summary_no_vehicle: "இன்னும் தேர்ந்தெடுக்கவில்லை",
    select_vehicle: "உங்கள் வாகனத்தைத் தேர்ந்தெடுங்கள்",
    select_vehicle_sub: "இரு வாகனங்களும் முழு காப்பீட்டுடன், முழு டாங்குடன் தயார்.",
    plate: "எண் தகடு",
    capacity: "கொள்ளளவு",
    max_weight: "சுமை",
    btn_select: "தேர்ந்தெடு",
    btn_back: "பின்",
    btn_next: "அடுத்து",
    btn_confirm: "ஒப்பந்தத்தை உறுதிப்படுத்து",
    btn_capture: "புகைப்படம் எடு",
    btn_retake: "மீண்டும் எடு",
    btn_use_photo: "புகைப்படத்தைப் பயன்படுத்து",
    btn_clear: "அழி",
    customer_title: "வாடிக்கையாளர் விவரங்கள்",
    customer_sub: "ஓட்டுநர் உரிமத்தில் உள்ளபடி அனைத்து விவரங்களையும் நிரப்புங்கள்.",
    f_full_name: "முழுப் பெயர்",
    f_address: "முகவரி",
    f_city: "நகரம்",
    f_postal: "அஞ்சல் குறியீடு",
    f_phone: "தொலைபேசி",
    f_email: "மின்னஞ்சல் (விருப்பம்)",
    f_license: "உரிம எண்",
    f_dob: "பிறந்த தேதி",
    f_start: "வாடகை தொடக்கம்",
    f_end: "வாடகை முடிவு (24 மணி)",
    id_title: "அடையாள அட்டையை படமெடு",
    id_sub: "உரிமத்தை சட்டகத்திற்குள் தெளிவாக வையுங்கள்.",
    id_camera_off: "கேமரா கிடைக்கவில்லை",
    id_grant: "உலாவியில் கேமரா அணுகலை அனுமதிக்கவும்.",
    id_or_upload: "அல்லது படத்தைப் பதிவேற்று",
    sig_title: "டிஜிட்டல் கையொப்பம்",
    sig_sub: "ஒப்பந்தத்தை சட்டப்பூர்வமாக்க இங்கே கையொப்பமிடுங்கள்.",
    sig_baseline: "கையொப்பம்",
    review_title: "ஒப்பந்தத்தை சரிபார்க்கவும்",
    review_sub: "சமர்ப்பிக்கும் முன் அனைத்து விவரங்களையும் சரிபார்க்கவும்.",
    confirmation_title: "ஒப்பந்தம் வெற்றிகரமாக உருவாக்கப்பட்டது",
    confirmation_sub: "வாடகை ஒப்பந்தம் சேமிக்கப்பட்டது.",
    contract_number: "ஒப்பந்த எண்",
    download_pdf: "PDF பதிவிறக்கு",
    new_contract: "புதிய ஒப்பந்தம்",
    login_title: "நிர்வாக உள்நுழைவு",
    login_sub: "NIVARA அதிகாரபூர்வ ஊழியர்களுக்கு மட்டும்.",
    login_back: "செயலிக்குத் திரும்பு",
    login_hero_a: "வாடகைக்கு.",
    login_hero_b: "புறப்படுங்கள்.",
    login_hero_text: "உங்கள் டிரான்ஸ்போர்ட்டர் வாகனங்கள் உடனடியாகக் கிடைக்கின்றன. ஆன்லைனில் முன்பதிவு செய்து செயின்ட் காலன், பெர்ன் அல்லது டெரெண்டிங்கனில் உள்ள எங்கள் நிலையங்களில் ஒன்றில் பெற்றுக்கொள்ளுங்கள்.",
    f_email_login: "மின்னஞ்சல்",
    f_password: "கடவுச்சொல்",
    btn_login: "உள்நுழை",
    login_error: "தவறான விவரங்கள்",
    admin_title: "ஒப்பந்தங்கள்",
    admin_sub: "அனைத்து செயலில் உள்ள மற்றும் கடந்த ஒப்பந்தங்கள்.",
    search_placeholder: "பெயர், ஒப்பந்த எண், உரிம எண் தேடு…",
    filter_all: "அனைத்து வாகனங்கள்",
    th_contract: "ஒப்பந்தம்",
    th_customer: "வாடிக்கையாளர்",
    th_vehicle: "வாகனம்",
    th_period: "காலம்",
    th_price: "விலை",
    th_actions: "",
    no_contracts: "ஒப்பந்தங்கள் காணப்படவில்லை.",
    view: "காண்",
    pdf: "PDF",
    delete: "நீக்கு",
    confirm_delete: "இந்த ஒப்பந்தத்தை நீக்கவா?",
    required: "தேவை",
    saving: "சேமிக்கிறது…",
    days: "நாட்கள்",
    beta_notice: "",
    step_config: "உள்ளமைப்பு",
    vehicle_pick_type_title: "எதை எடுத்துச் செல்ல விரும்புகிறீர்கள்?",
    vehicle_pick_type_sub: "மக்களா அல்லது சரக்குகளா? இரு கிளிக்கில் சரியான வாகனம்.",
    vehicle_pick_station_title: "இடம் தேர்ந்தெடு",
    vehicle_pick_station_sub: "உங்கள் வாகனத்தைப் பெறும் இடத்தைத் தேர்ந்தெடுக்கவும். சரியான வாகனம் தானாக ஒதுக்கப்படும்.",
    vehicle_type_passenger: "பயணி வேன்",
    vehicle_type_passenger_sub: "Mercedes Vito · 9 இருக்கைகள்",
    vehicle_type_cargo: "சரக்கு வேன்",
    vehicle_type_cargo_sub: "Renault Master · 1500 கி.கி. வரை",
    price_from_per_day: "CHF 190.– / நாள் முதல்",
    price_from_per_3h: "CHF 80.– / 3 மணி முதல்",
    change_vehicle_type: "வாகன வகையை மாற்று",
    station_label: "இடம்",
    selected_label: "தேர்ந்தெடுக்கப்பட்டது",
    no_stations_available: "தற்போது இடங்கள் கிடைக்கவில்லை.",
    pickup_location: "எடுக்கும் இடம்",
    pickup_location_pick: "எடுக்கும் இடத்தைத் தேர்ந்தெடு",
    vito_config_eyebrow: "Vito · உள்ளமைப்பு",
    vito_config_title: "பயணத்தை அமை",
    vito_config_sub: "இலக்கு, தொடக்க மற்றும் திருப்பித் தேதி/நேரம். கி.மீ. வரம்பு இல்லை.",
    destination_label: "இலக்கு",
    destination_ch: "சுவிட்சர்லாந்து",
    destination_ch_sub: "உள்நாடு",
    destination_eu: "வெளிநாடு (EU)",
    destination_eu_sub: "ஐரோப்பா",
    start_date: "தொடக்க தேதி",
    start_time: "தொடக்க நேரம்",
    handover_time_hint: "இடத்தில் ஒப்படை நேரம்.",
    days_count_label: "நாட்கள் (1–14)",
    day_singular: "நாள்",
    weekend_tariff: "வார இறுதி கட்டணம்",
    weekday_tariff: "வார நாள் கட்டணம்",
    vito_price_footer: "கி.மீ. வரம்பு இல்லை · முழு காப்பீடு உட்பட CHF 1'000 கழிவு",
    master_config_eyebrow: "Master · தொகுப்பு",
    master_config_title: "தொகுப்பைத் தேர்ந்தெடு",
    master_config_sub: "கி.மீ. உட்பட்ட 3 தொகுப்புகள். கூடுதல் கி.மீ. CHF 0.35. புதன்கிழமை மூடப்பட்டுள்ளது.",
    package_label: "தொகுப்பு",
    km_included: "கி.மீ. உட்பட",
    km_included_short: "உட்பட",
    date_label: "தேதி",
    wednesday_blocked: "புதன்கிழமை முன்பதிவு செய்ய முடியாது.",
    start_time_range: "தொடக்க நேரம் (08:00–20:00)",
    opening_hours_only: "08:00–20:00 மட்டுமே",
    expected_km_opt: "எதிர்பார்த்த கி.மீ. (விருப்பம்)",
    package_price: "தொகுப்பு விலை",
    extra_km_overtime_info: "கூடுதல் கி.மீ. CHF 0.35 · கூடுதல் நேரம் CHF 25/மணி",
    master_price_footer: "முழு காப்பீடு உட்பட · புதன்கிழமை மூடப்பட்டுள்ளது",
    customer_search_title: "உள்ள வாடிக்கையாளரைத் தேடுங்கள்",
    customer_search_placeholder: "பெயர், உரிம எண், தொலைபேசி அல்லது மின்னஞ்சல்…",
    searching: "தேடுகிறது…",
    no_results: "முடிவுகள் இல்லை.",
    payment_method_label: "வாகனம் எடுக்கும்போது கட்டணம்",
    payment_twint_sub: "ஒப்பந்தத்தில் QR குறியீடு · செல்போன் கட்டணம்",
    payment_cash_title: "ரொக்கம்",
    payment_cash_sub: "வாகனம் எடுக்கும்போது CHF இல் கட்டணம்",
    vehicles_load_error: "வாகனங்களை ஏற்ற முடியவில்லை.",
    submit_error: "சேமிக்கும்போது பிழை. மீண்டும் முயற்சிக்கவும்.",
    term_master_packages: "Master தொகுப்புகள்",
    term_extra_km: "கூடுதல் கி.மீ.",
    term_overtime: "கூடுதல் நேரம்",
    term_daily_ch: "தினச் கட்டணம் (CH)",
    term_abroad_eu: "வெளிநாடு (EU)",
    term_from: "முதல்",
    term_km_limit: "கி.மீ. வரம்பு",
    term_km_none: "இல்லை",
    summary_brand_tag: "வேன் வாடகை",
    language_label: "மொழி",
    confirmation_sent_email: "{email} க்கு உறுதிப்படுத்தல் அனுப்பப்பட்டது.",
    confirmation_no_email: "எடுக்கும்போதே ஒப்பந்த எண்ணைக் குறித்து வைக்கவும்.",
    confirmation_help: "கேள்விகளுக்கு எங்களைத் தொடர்பு கொள்ளவும்:",
    send_by_email: "மின்னஞ்சல் வழியாக அனுப்பு",
    back_to_home: "முகப்பிற்குத் திரும்பு",
    btn_cancel: "ரத்து",
    btn_send: "அனுப்பு",
  },
  // ─────────────────────────────────────────────────────────────────────────
  // ትግርኛ (Tigrinya) — Beta machine translation, please have a native speaker review
  // ─────────────────────────────────────────────────────────────────────────
  ti: {
    brand_tagline: "ናይ ትራንስፖርተር ክራይ",
    nav_admin: "ኣድሚን",
    nav_logout: "ውጻእ",
    hero_eyebrow: "ስዊዘርላንዳዊ ናይ ትራንስፖርተር ክራይ",
    hero_title: "ትራንስፖርተር ተኻረ።\nብደቓይቕ።",
    hero_sub: "Mercedes Vito ከምኡውን Renault Master። 700 CHF ንሓሙሽተ መዓልታት። ምሉእ ናፍጣ። ብዘይ ሓደጋ።",
    cta_start: "ክራይ ጀምር",
    cta_admin_login: "ናይ ኣድሚን ክፍሊ",
    rental_type_title: "ታሪፍ ምረጽ",
    rental_type_daily: "መዓልታዊ ክራይ · 24 ሰዓታት",
    rental_type_daily_desc: "ብ24 ሰዓት CHF 140.–",
    rental_type_hourly: "ሰዓታዊ ታሪፍ",
    rental_type_hourly_desc: "CHF 25.–/ሰዓት · 200 ኪሎ ሜተር ሕውስ · ተወሳኺ CHF 0.25/ኪሜ",
    expected_km: "ዝተሓሰበ ኪሜ",
    duration: "ግዜ",
    hours_short: "ሰዓ",
    total_price: "ጠቕላላ ዋጋ",
    station_title: "ሙያዊ ኣካያዲ",
    station_sub: "ምድላው · ምርካብ · ምምላስ",
    status_pending: "ተጸብየ",
    status_ready: "ድሉው",
    status_handed_over: "ተረኪቡ",
    status_returned: "ተመሊሱ",
    status_completed: "ተዛዚሙ",
    status_cancelled: "ተሰሪዙ",
    set_status: "ሁኔታ ኣቐምጥ",
    odometer_start: "መጀመሪ ኪሜ",
    odometer_end: "መወዳእታ ኪሜ",
    mark_ready: "ድሉው ምልክት ግበር",
    mark_handed_over: "ምስልጣ",
    mark_returned: "ምምላስ",
    mark_completed: "ዛዝም",
    stats_total_contracts: "ጠቕላላ ውዕላት",
    stats_total_revenue: "ኣታዊ CHF",
    stats_total_hours: "ጠቕላላ ሰዓታት",
    stats_per_vehicle: "ብመኪና",
    stats_status: "ኩነታት",
    nav_calendar: "ዓውደ-ኣዋርሕ",
    nav_register: "ተመዝገብ",
    nav_my: "ናተይ ክፍሊ",
    nav_login: "እተው",
    register_title: "ናይ ዓማዊል መርበብ ስራሕ",
    register_sub: "ብቕልጡፍ ተመዝገብ ኦንላይን ጠለብ ግበር።",
    register_cta: "መርበብ ስራሕ",
    have_account: "ቅድሚ ሕጂ ኣካውንት ኣሎካ?",
    no_account: "ኣካውንት የብልካን?",
    calendar_title: "ምርካብ",
    calendar_sub: "ብመኪና ዝተሓዘ / ናጻ ዝኾነ።",
    calendar_legend_free: "ናጻ",
    calendar_legend_partial: "ኣካል",
    calendar_legend_booked: "ተሓዙ",
    my_title: "ናተይ ጠለባት",
    my_sub: "ናይ ውዕላትካ ኣጠቓላሊ።",
    book_now: "ሕጂ ጠለብ ግበር",
    conflict_error: "ኣብቲ ዝተመረጸ ግዜ መኪና ቅድሚ ሕጂ ተሓዚ ኣሎ።",
    handover_title: "ናይ መኪና ምስልጣ ዝስነድ",
    return_title: "ናይ መኪና ምምላስ ዝስነድ",
    odometer_helper: "ሕጂ ዘሎ ኪሎ ሜተር ካብ ታኮ ኣንብብ።",
    vehicle_photo: "ናይ መኪና ስእሊ",
    vehicle_photo_hint: "ናይ መኪና ስእሊ ስሓብ (ጉድኣት / ሓፈሻዊ ኩነታት)",
    profile_title: "ናተይ ፕሮፋይል",
    profile_sub: "ብዝተዓቐበ መረዳእታ ኩሉ ጠለብ ብኣውቶማቲክ ይምላእ።",
    profile_save: "ፕሮፋይል ኣቐምጥ",
    profile_saved: "ፕሮፋይል ተቐሚጡ",
    handover_photo_label: "ስእሊ ምስልጣ",
    return_photo_label: "ስእሊ ምምላስ",
    agb_title: "ሓፈሻዊ ኩነታት ንግዲ",
    agb_accept_label: "ሓፈሻዊ ኩነታት ኣንቢበ፣ ተረዲኤ ተቐቢለዮ። ብምርግጋጽ ናይ ክራይ ውዕል ሕጋዊ ይኸውን።",
    agb_required: "ንኽትቅጽል በጃኻ ሓፈሻዊ ኩነታት ተቐበል።",
    defects_label: "ኣብ ምስልጣ ዝነበረ ጉድኣት (ምርጫ)",
    defects_placeholder: "ንኣብነት ድሕሪት የማን ዝተዘክሮ፣ ኣብ ቅድሚት ምስኳዕ ዕምባባ…",
    defects_helper: "ዝነበረ ጉድኣት ብዝርዝር ኣስፍሮ። ዘይተሰነደ ጉድኣት ናብ ተኻራዪ ይምለስ።",
    step_vehicle: "መኪና",
    step_customer: "ዓማዊል",
    step_id: "መለለዪ",
    step_signature: "ፊርማ",
    step_review: "ኣጠቓላሊ",
    step_done: "ተዛዚሙ",
    summary_title: "ናትካ ጠለብ",
    summary_terms: "ኩነታት",
    summary_price: "ዋጋ",
    summary_price_value: "CHF 140.– / 24 ሰዓት",
    summary_deposit: "ውሕስነት",
    summary_deductible: "ድኻ ዘይከውን ድርሻ",
    summary_fuel: "ናፍጣ",
    summary_fuel_value: "ኣብ ምስልጣን ምምላስን ምሉእ ናፍጣ",
    summary_vehicle: "መኪና",
    summary_no_vehicle: "ገና ኣይተመረጸን",
    select_vehicle: "መኪናኻ ምረጽ",
    select_vehicle_sub: "ክልቲኦም መካይን ምሉእ ናፍጣ ኣለዎምን ምሉእ ኢንሹራንስ ኣለዎምን።",
    plate: "ቁጽሪ ሰሌዳ",
    capacity: "ዓቕሚ",
    max_weight: "ጾር",
    btn_select: "ምረጽ",
    btn_back: "ድሕሪት",
    btn_next: "ቀጽል",
    btn_confirm: "ውዕል ኣረጋግጽ",
    btn_capture: "ስእሊ ስሓብ",
    btn_retake: "እንደገና ስሓብ",
    btn_use_photo: "ስእሊ ተጠቐም",
    btn_clear: "ኣጥፍእ",
    customer_title: "ናይ ዓማዊል መረዳእታ",
    customer_sub: "ኩሉ ቦታታት ከም ናይ ምራሕ ፍቓድ ምልኣዮ።",
    f_full_name: "ምሉእ ሽም",
    f_address: "ኣድራሻ",
    f_city: "ከተማ",
    f_postal: "ናይ ፖስታ ቁጽሪ",
    f_phone: "ቴለፎን",
    f_email: "ኢመይል (ምርጫ)",
    f_license: "ቁጽሪ ምራሕ ፍቓድ",
    f_dob: "ዕለተ ልደት",
    f_start: "መጀመሪ ክራይ",
    f_end: "መወዳእታ ክራይ (24 ሰዓ)",
    id_title: "መለለዪ ስሓብ",
    id_sub: "ምራሕ ፍቓድ ብጽሬት ኣብ ፍሬም ሓዞ።",
    id_camera_off: "ካሜራ የለን",
    id_grant: "በጃኻ ካሜራ ኣብ ብራውዘር ኣፍቅድ።",
    id_or_upload: "ወይ ስእሊ ኣሳዕር",
    sig_title: "ዲጂታል ፊርማ",
    sig_sub: "ውዕል ብሕጋዊ መንገዲ ንምዕጻው ኣብዚ ፍሪሞ።",
    sig_baseline: "ፊርማ",
    review_title: "ውዕል ሕለፎ",
    review_sub: "ቅድሚ ምዝዛም ኩሉ መረዳእታ ሕለፎ።",
    confirmation_title: "ውዕል ብዓወት ተፈጢሩ",
    confirmation_sub: "ናይ ክራይ ውዕል ተቐሚጡ።",
    contract_number: "ቁጽሪ ውዕል",
    download_pdf: "PDF ኣሳዕር",
    new_contract: "ሓዲሽ ውዕል",
    login_title: "ናይ ኣድሚን መእተዊ",
    login_sub: "ንስልጣን ዘለዎ ናይ NIVARA ሰራሕተኛ ጥራይ።",
    login_back: "ናብ መተግበሪ ተመለስ",
    login_hero_a: "ተኻርይ።",
    login_hero_b: "ተበገስ።",
    login_hero_text: "መጓዓዝያኹም ሕጂ ቅሩብ። ኦንላይን ሓዙ ኣብ ሰይንት ጋለን፣ በርን ወይ ደረንዲንገን ካብ ዘለዉና ጣብያታት ኣብ ሓደ ተቐበሉ።",
    f_email_login: "ኢመይል",
    f_password: "ምስጢራዊ ቓል",
    btn_login: "እተው",
    login_error: "ዘይቅኑዕ መረዳእታ",
    admin_title: "ውዕላት",
    admin_sub: "ኩሉ ዘሎን ዝሓለፈን ናይ ክራይ ውዕላት።",
    search_placeholder: "ብሽም፣ ቁጽሪ ውዕል፣ ቁጽሪ ምራሕ ፍቓድ ድለ…",
    filter_all: "ኩለን መካይን",
    th_contract: "ውዕል",
    th_customer: "ዓማዊል",
    th_vehicle: "መኪና",
    th_period: "ግዜ",
    th_price: "ዋጋ",
    th_actions: "",
    no_contracts: "ውዕላት ኣይተረኽቡን።",
    view: "ርአ",
    pdf: "PDF",
    delete: "ሰርዝ",
    confirm_delete: "ነዚ ውዕል ብርግጽ ክትሰርዞ ትደሊ?",
    required: "ግዴታዊ ቦታ",
    saving: "ይቕመጥ…",
    days: "መዓልታት",
    beta_notice: "⚠ ቤታ ትርጉም — ምስ ዓማዊል ናይ ኣጠቓቕማ ቅድሚ ናይ ቋንቋ ኣፍ ሊቓዊ ምርመራ።",
    step_config: "ቅንብር",
    vehicle_pick_type_title: "እንታይ ኢኹም ክትጭዓኑ ትደልዩ?",
    vehicle_pick_type_sub: "ሰባት ወይ ጾር? ኣብ ክልተ ጠዋቒ ቅኑዕ መኪና።",
    vehicle_pick_station_title: "ቦታ ምረጽ",
    vehicle_pick_station_sub: "ቦታ ምውሳድ ምረጽ። ቅኑዕ መኪና ብኣውቶማቲክ ይምደብ።",
    vehicle_type_passenger: "ናይ ሰብ መኪና",
    vehicle_type_passenger_sub: "Mercedes Vito · 9 ቦታታት",
    vehicle_type_cargo: "ናይ ጾር መኪና",
    vehicle_type_cargo_sub: "Renault Master · ክሳዕ 1500 ኪሎ",
    price_from_per_day: "ካብ CHF 190.– / መዓልቲ",
    price_from_per_3h: "ካብ CHF 80.– / 3 ሰዓት",
    change_vehicle_type: "ናይ መኪና ዓይነት ቀይር",
    station_label: "ቦታ",
    selected_label: "ተመረጸ",
    no_stations_available: "ሕጂ ዘሎ ቦታ የለን።",
    pickup_location: "መውሰዲ ቦታ",
    pickup_location_pick: "መውሰዲ ቦታ ምረጽ",
    vito_config_eyebrow: "Vito · ቅንብር",
    vito_config_title: "ጉዕዞ ኣዳሉ",
    vito_config_sub: "መዓላማ፣ ዕለትን ሰዓትን ምጅማርን ምምላስን። ዘይብሉ ናይ ኪሜ ድሮ።",
    destination_label: "መዓላማ",
    destination_ch: "ስዊዘርላንድ",
    destination_ch_sub: "ውሽጢ ሃገር",
    destination_eu: "ወጻኢ (EU)",
    destination_eu_sub: "ኤውሮጳ",
    start_date: "ዕለተ ምጅማር",
    start_time: "ሰዓት ምጅማር",
    handover_time_hint: "ኣብ ቦታ ምስ ምውሳድ።",
    days_count_label: "ብዝሒ መዓልታት (1–14)",
    day_singular: "መዓልቲ",
    weekend_tariff: "ናይ ቀዳምን ሰንበትን ታሪፍ",
    weekday_tariff: "ናይ ስራሕ መዓልታት ታሪፍ",
    vito_price_footer: "ዘይብሉ ናይ ኪሜ ድሮ · ምሉእ ኢንሹራንስ ምስ CHF 1'000 ድኻ",
    master_config_eyebrow: "Master · ጥሙር",
    master_config_title: "ጥሙር ምረጽ",
    master_config_sub: "3 ጥሙራት ምስ ኪሜ ሕውስ። ተወሳኺ ኪሜ CHF 0.35. ረቡዕ ዕጹው።",
    package_label: "ጥሙር",
    km_included: "ኪሜ ሕውስ",
    km_included_short: "ሕውስ",
    date_label: "ዕለት",
    wednesday_blocked: "ረቡዕ ኣይክፋእን።",
    start_time_range: "ሰዓት ምጅማር (08:00–20:00)",
    opening_hours_only: "08:00–20:00 ጥራይ",
    expected_km_opt: "ዝተሓሰበ ኪሜ (ምርጫ)",
    package_price: "ዋጋ ጥሙር",
    extra_km_overtime_info: "ተወሳኺ ኪሜ CHF 0.35 · ተወሳኺ ሰዓት CHF 25/ሰዓ",
    master_price_footer: "ምሉእ ኢንሹራንስ · ረቡዕ ዕጹው",
    customer_search_title: "ነባር ዓማዊል ድለ",
    customer_search_placeholder: "ሽም፣ ቁጽሪ ፍቓድ፣ ቴለፎን ወይ ኢመይል…",
    searching: "ይድሊ…",
    no_results: "ውጽኢት የለን።",
    payment_method_label: "ኣብ ምውሳድ ዓይነት ክፍሊት",
    payment_twint_sub: "QR ኣብ ውዕል · ብሞባይል ክፍሊት",
    payment_cash_title: "ናቕፋ",
    payment_cash_sub: "ኣብ ምውሳድ መኪና ብ CHF ይከፈል",
    vehicles_load_error: "መካይን ክጻዕኑ ኣይተኻእለን።",
    submit_error: "ኣብ ምቕማጥ ጌጋ። እንደገና ፈትን።",
    term_master_packages: "ጥሙራት Master",
    term_extra_km: "ተወሳኺ ኪሜ",
    term_overtime: "ተወሳኺ ሰዓት",
    term_daily_ch: "መዓልታዊ (CH)",
    term_abroad_eu: "ወጻኢ (EU)",
    term_from: "ካብ",
    term_km_limit: "ናይ ኪሜ ድሮ",
    term_km_none: "የለን",
    summary_brand_tag: "ናይ ትራንስፖርተር ክራይ",
    language_label: "ቋንቋ",
    confirmation_sent_email: "ናብ {email} ምርግጋጽ ተላኢኹ።",
    confirmation_no_email: "በጃኹም ኣብ ምውሳድ ቁጽሪ ውዕል ሓዙ።",
    confirmation_help: "ሕቶታት እንተሃልዩ ደውሉ:",
    send_by_email: "ብ ኢመይል ለኣኽ",
    back_to_home: "ናብ ቤት ተመለስ",
    btn_cancel: "ሰርዝ",
    btn_send: "ለኣኽ",
  },
  // ─────────────────────────────────────────────────────────────────────────
  // العربية (Arabic) — Beta machine translation, please have a native speaker review
  // ─────────────────────────────────────────────────────────────────────────
  ar: {
    brand_tagline: "تأجير شاحنات النقل",
    nav_admin: "المسؤول",
    nav_logout: "تسجيل الخروج",
    hero_eyebrow: "تأجير شاحنات سويسرية",
    hero_title: "استأجر شاحنة.\nفي دقائق.",
    hero_sub: "Mercedes Vito و Renault Master. سعر ثابت 700 فرنك سويسري لخمسة أيام. خزان وقود ممتلئ. بدون مفاجآت.",
    cta_start: "ابدأ التأجير",
    cta_admin_login: "منطقة المسؤول",
    rental_type_title: "اختر التعرفة",
    rental_type_daily: "إيجار يومي · 24 ساعة",
    rental_type_daily_desc: "140 فرنك سويسري لكل 24 ساعة",
    rental_type_hourly: "تعرفة بالساعة",
    rental_type_hourly_desc: "25 فرنك/ساعة · 200 كم مشمولة · 0.25 فرنك/كم إضافي",
    expected_km: "الكيلومترات المتوقعة",
    duration: "المدة",
    hours_short: "س",
    total_price: "السعر الإجمالي",
    station_title: "مدير المحطة",
    station_sub: "تحضير · تسليم · استلام",
    status_pending: "قيد الانتظار",
    status_ready: "جاهز",
    status_handed_over: "تم التسليم",
    status_returned: "تم الإرجاع",
    status_completed: "مكتمل",
    status_cancelled: "ملغى",
    set_status: "تعيين الحالة",
    odometer_start: "عداد البداية",
    odometer_end: "عداد النهاية",
    mark_ready: "تحديد كجاهز",
    mark_handed_over: "تسليم",
    mark_returned: "إرجاع",
    mark_completed: "إغلاق",
    stats_total_contracts: "إجمالي العقود",
    stats_total_revenue: "الإيرادات بالفرنك",
    stats_total_hours: "إجمالي الساعات",
    stats_per_vehicle: "حسب المركبة",
    stats_status: "نظرة على الحالة",
    nav_calendar: "التقويم",
    nav_register: "تسجيل",
    nav_my: "منطقتي",
    nav_login: "تسجيل الدخول",
    register_title: "إنشاء حساب عميل",
    register_sub: "سجل بسرعة واحجز عبر الإنترنت مباشرة.",
    register_cta: "إنشاء حساب",
    have_account: "هل لديك حساب بالفعل؟",
    no_account: "ليس لديك حساب؟",
    calendar_title: "التوافر",
    calendar_sub: "نظرة عامة على المحجوز / المتاح لكل مركبة.",
    calendar_legend_free: "متاح",
    calendar_legend_partial: "جزئي",
    calendar_legend_booked: "محجوز",
    my_title: "حجوزاتي",
    my_sub: "نظرة عامة على عقود إيجارك.",
    book_now: "احجز الآن",
    conflict_error: "المركبة محجوزة بالفعل في الفترة المختارة.",
    handover_title: "توثيق تسليم المركبة",
    return_title: "توثيق إرجاع المركبة",
    odometer_helper: "اقرأ مسافة الكيلومترات الحالية من العداد.",
    vehicle_photo: "صورة المركبة",
    vehicle_photo_hint: "التقط صورة للمركبة (الأضرار / الحالة العامة)",
    profile_title: "ملفي الشخصي",
    profile_sub: "ستتم تعبئة البيانات تلقائياً في كل حجز.",
    profile_save: "حفظ الملف",
    profile_saved: "تم حفظ الملف",
    handover_photo_label: "صورة التسليم",
    return_photo_label: "صورة الإرجاع",
    agb_title: "الشروط والأحكام العامة",
    agb_accept_label: "لقد قرأت وفهمت ووافقت على الشروط والأحكام. بالتأكيد يصبح عقد الإيجار ملزماً قانونياً.",
    agb_required: "يرجى قبول الشروط والأحكام للمتابعة.",
    defects_label: "العيوب عند الاستلام (اختياري)",
    defects_placeholder: "مثال: خدش خلفي يمين، صدمة حجر في الزجاج الأمامي...",
    defects_helper: "يرجى سرد أي عيوب بالتفصيل. الأضرار غير الموثقة تكون على عاتق المستأجر.",
    step_vehicle: "المركبة",
    step_customer: "بيانات العميل",
    step_id: "الهوية",
    step_signature: "التوقيع",
    step_review: "المراجعة",
    step_done: "تم",
    summary_title: "حجزك",
    summary_terms: "الشروط",
    summary_price: "السعر",
    summary_price_value: "140 فرنك / 24 ساعة",
    summary_deposit: "التأمين",
    summary_deductible: "التحمل",
    summary_fuel: "الوقود",
    summary_fuel_value: "خزان ممتلئ عند التسليم والإرجاع",
    summary_vehicle: "المركبة",
    summary_no_vehicle: "لم يتم الاختيار بعد",
    select_vehicle: "اختر مركبتك",
    select_vehicle_sub: "كلا المركبتين مؤمنتان بالكامل وجاهزتان بخزان ممتلئ.",
    plate: "رقم اللوحة",
    capacity: "السعة",
    max_weight: "الحمولة",
    btn_select: "اختيار",
    btn_back: "رجوع",
    btn_next: "التالي",
    btn_confirm: "تأكيد العقد",
    btn_capture: "التقاط صورة",
    btn_retake: "إعادة التقاط",
    btn_use_photo: "استخدام الصورة",
    btn_clear: "مسح",
    customer_title: "بيانات العميل",
    customer_sub: "يرجى ملء جميع الحقول كما هي في رخصة القيادة.",
    f_full_name: "الاسم الكامل",
    f_address: "العنوان",
    f_city: "المدينة",
    f_postal: "الرمز البريدي",
    f_phone: "الهاتف",
    f_email: "البريد الإلكتروني (اختياري)",
    f_license: "رقم رخصة القيادة",
    f_dob: "تاريخ الميلاد",
    f_start: "بداية الإيجار",
    f_end: "نهاية الإيجار (24 ساعة)",
    id_title: "تصوير الهوية",
    id_sub: "ضع رخصة القيادة بوضوح داخل الإطار.",
    id_camera_off: "الكاميرا غير متاحة",
    id_grant: "يرجى السماح بالوصول إلى الكاميرا في المتصفح.",
    id_or_upload: "أو ارفع صورة",
    sig_title: "التوقيع الرقمي",
    sig_sub: "وقّع هنا لإبرام عقد الإيجار قانونياً.",
    sig_baseline: "التوقيع",
    review_title: "مراجعة العقد",
    review_sub: "راجع جميع البيانات قبل الإتمام.",
    confirmation_title: "تم إنشاء العقد بنجاح",
    confirmation_sub: "تم حفظ عقد الإيجار.",
    contract_number: "رقم العقد",
    download_pdf: "تحميل PDF",
    new_contract: "عقد جديد",
    login_title: "تسجيل دخول المسؤول",
    login_sub: "الوصول مخصص لموظفي NIVARA المخولين فقط.",
    login_back: "العودة إلى التطبيق",
    login_hero_a: "استأجر.",
    login_hero_b: "انطلق.",
    login_hero_text: "شاحناتكم متوفرة فوراً. احجزوا عبر الإنترنت واستلموا من إحدى محطاتنا في سانت غالن أو برن أو ديريندينغن.",
    f_email_login: "البريد الإلكتروني",
    f_password: "كلمة المرور",
    btn_login: "تسجيل الدخول",
    login_error: "بيانات اعتماد غير صحيحة",
    admin_title: "العقود",
    admin_sub: "جميع عقود الإيجار الفعالة والسابقة.",
    search_placeholder: "ابحث بالاسم أو رقم العقد أو رخصة القيادة…",
    filter_all: "جميع المركبات",
    th_contract: "العقد",
    th_customer: "العميل",
    th_vehicle: "المركبة",
    th_period: "الفترة",
    th_price: "السعر",
    th_actions: "",
    no_contracts: "لم يتم العثور على عقود.",
    view: "عرض",
    pdf: "PDF",
    delete: "حذف",
    confirm_delete: "هل تريد فعلاً حذف هذا العقد؟",
    required: "حقل إلزامي",
    saving: "جارٍ الحفظ…",
    days: "أيام",
    beta_notice: "⚠ ترجمة تجريبية — للاستخدام مع العملاء يرجى المراجعة من قبل متحدث أصلي.",
    step_config: "الإعداد",
    vehicle_pick_type_title: "ماذا تريد أن تنقل؟",
    vehicle_pick_type_sub: "أشخاص أم بضائع؟ في نقرتين تصل إلى المركبة المناسبة.",
    vehicle_pick_station_title: "اختر الموقع",
    vehicle_pick_station_sub: "اختر موقع الاستلام. سيتم تخصيص المركبة المناسبة تلقائياً.",
    vehicle_type_passenger: "مركبة ركاب",
    vehicle_type_passenger_sub: "Mercedes Vito · 9 مقاعد",
    vehicle_type_cargo: "مركبة بضائع",
    vehicle_type_cargo_sub: "Renault Master · حتى 1500 كجم",
    price_from_per_day: "ابتداءً من 190 فرنك / يوم",
    price_from_per_3h: "ابتداءً من 80 فرنك / 3 س",
    change_vehicle_type: "تغيير نوع المركبة",
    station_label: "الموقع",
    selected_label: "محدد",
    no_stations_available: "لا توجد مواقع متاحة حالياً.",
    pickup_location: "موقع الاستلام",
    pickup_location_pick: "اختر موقع الاستلام",
    vito_config_eyebrow: "Vito · الإعداد",
    vito_config_title: "إعداد الرحلة",
    vito_config_sub: "الوجهة وتاريخ ووقت البدء والعودة. بدون حد للكيلومترات.",
    destination_label: "الوجهة",
    destination_ch: "سويسرا",
    destination_ch_sub: "محلي",
    destination_eu: "خارج البلاد (الاتحاد الأوروبي)",
    destination_eu_sub: "أوروبا",
    start_date: "تاريخ البدء",
    start_time: "وقت البدء",
    handover_time_hint: "وقت التسليم في الموقع.",
    days_count_label: "عدد الأيام (1–14)",
    day_singular: "يوم",
    weekend_tariff: "تعرفة نهاية الأسبوع",
    weekday_tariff: "تعرفة أيام الأسبوع",
    vito_price_footer: "بدون حد للكيلومترات · تأمين شامل مع تحمل 1'000 فرنك",
    master_config_eyebrow: "Master · باقة",
    master_config_title: "اختر باقة",
    master_config_sub: "3 باقات مع كيلومترات مشمولة. كم إضافي 0.35 فرنك. مغلق الأربعاء.",
    package_label: "الباقة",
    km_included: "كم مشمول",
    km_included_short: "مشمول",
    date_label: "التاريخ",
    wednesday_blocked: "الأربعاء غير متاح للحجز.",
    start_time_range: "وقت البدء (08:00–20:00)",
    opening_hours_only: "فقط 08:00–20:00",
    expected_km_opt: "الكيلومترات المتوقعة (اختياري)",
    package_price: "سعر الباقة",
    extra_km_overtime_info: "كم إضافي 0.35 فرنك · وقت إضافي 25 فرنك/ساعة",
    master_price_footer: "تأمين شامل · مغلق الأربعاء",
    customer_search_title: "البحث عن عميل موجود",
    customer_search_placeholder: "الاسم أو رقم الرخصة أو الهاتف أو البريد…",
    searching: "جارٍ البحث…",
    no_results: "لا توجد نتائج.",
    payment_method_label: "طريقة الدفع عند الاستلام",
    payment_twint_sub: "رمز QR على العقد · دفع عبر الهاتف",
    payment_cash_title: "نقدي",
    payment_cash_sub: "الدفع بالفرنك عند استلام المركبة",
    vehicles_load_error: "تعذر تحميل المركبات.",
    submit_error: "حدث خطأ أثناء الحفظ. يرجى المحاولة مرة أخرى.",
    term_master_packages: "باقات Master",
    term_extra_km: "كم إضافي",
    term_overtime: "وقت إضافي",
    term_daily_ch: "تعرفة يومية (CH)",
    term_abroad_eu: "خارج البلاد (الاتحاد الأوروبي)",
    term_from: "من",
    term_km_limit: "حد الكيلومترات",
    term_km_none: "بدون",
    summary_brand_tag: "تأجير الشاحنات",
    language_label: "اللغة",
    confirmation_sent_email: "تم إرسال التأكيد إلى {email}.",
    confirmation_no_email: "يرجى تدوين رقم العقد للاستلام.",
    confirmation_help: "لأي استفسار اتصل بنا:",
    send_by_email: "إرسال عبر البريد الإلكتروني",
    back_to_home: "العودة إلى الصفحة الرئيسية",
    btn_cancel: "إلغاء",
    btn_send: "إرسال",
  },
};

export const t = (lang, key) => {
  const dict = translations[lang] || translations.de;
  return dict[key] ?? translations.de[key] ?? key;
};
